import type { DatovkaApiType } from '@gov-nx/api';
import { unique } from '@gov-nx/core/types';
import { dataBoxParams, toStringDate } from '@gov-nx/utils/common';
import { PpdfSouhlasyTypOsobyEnum, type ZapisForm } from './context.types';
import type { Params, Body } from './prepareSubmitData.types';

export const prepareSubmitData = (
	formData: ZapisForm,
	// Will perhaps be used after discussion with BE on how to handle
	// REZA and databoxes together
	_dataBoxInfo: DatovkaApiType | undefined,
	poIco: number | undefined
): {
	params: Params;
	body: Body;
} => {
	const { datovaSchrankaId, ...params } = dataBoxParams(formData);

	const submitDataBoxId =
		formData.personType === PpdfSouhlasyTypOsobyEnum.FO
			? datovaSchrankaId
			: formData.poDataBoxId;

	return {
		params: {
			odesilatelDSId: datovaSchrankaId,
			...params,
		},
		body: {
			typOsoby: 'FO', // Hardcoded until we discuss REZA application with backend
			...(formData.personType === PpdfSouhlasyTypOsobyEnum.PO && {
				poIco,
				poDs: submitDataBoxId,
			}),
			kodSpravceUdaju: formData.fromOvmId,
			kodAgendySpravceUdaju: formData.fromAgendaId,
			kodPrijemceUdaju: formData.toOvmId?.selected?.kod,
			...(formData.toAgendaId && {
				kodAgendyPrijemceUdaju: formData.toAgendaId,
			}),
			datumTrvaniUdeleniSouhlasu:
				formData.consentValidityInterval === 'URCITY' &&
				formData.dateOfValidityConsent
					? toStringDate(formData.dateOfValidityConsent)
					: undefined,
			udaje: unique(formData.sharedAgendaMultiselect),
		},
	};
};
